/*
 * @Author: Gary
 * @Date: 2017-09-06 17:23:33
 * @Last Modified by: yuxiaojing
 * @Last Modified time: 2018-02-22 13:32:54
 * 封装axios
 */
import axios from 'axios'
import { Toast } from 'mint-ui'
import { getToken } from './auth'
// const baseUrl='http://www.trendbank.net:18000'
const baseUrl='http://192.168.1.200:18000/'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  // baseURL: baseUrl,
  timeout: 16000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    // if (getToken()) {
    //   config.headers['X-Auth-Token']='Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxODAxNTU5MDA4NSIsImlzcyI6IjE4MDE1NTkwMDg1IiwiaWF0IjowfQ.KrFpG7BpmQypuYl3Wmo4xFQSoE5f3qKsKxz_AmbDvHgAEBS6S9HWN44LNluUUqGESyL-hjQsZhk55EdiB2YFtw'
    // }

    if (getToken()) {
      config.headers['X-Auth-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      // config.headers['X-Auth-Token']= accentToken.token;
    }

    return config
  },
  error => {
    // Do something with request error
    console.dir(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return response.data
    } else {
      Toast({
        message: response.data,
        type: 'error',
        duration: 5 * 1000
      })
      let error = new Error(response.data)
      return Promise.reject(error)
    }
  },
  error => {
    console.dir(error)
    Toast(error.response.data.message)
    return Promise.reject(error)
  }
)

service.get = (path, params) => {
  return service({
    url: path,
    method: 'get',
    data: params,
    transformRequest: function (obj) {
      let ret = ''
      for (let it in obj) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(obj[it]) + '&'
      }
      // console.log(ret)
      return ret
    }
  })
}

service.post = (path, params) => {
  return service({
    url: path,
    method: 'post',
    data: params,
    transformRequest: function (obj) {
      let ret = ''
      for (let it in obj) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(obj[it]) + '&'
      }
      return ret
    }
  })
}

service.postJson = (path, params) => {
  return service({
    url: path,
    method: 'post',
    data: params,
    transformRequest: function (obj) {
      return JSON.stringify(obj)
    },
    headers: { 'Content-Type': 'application/json' }
  })
}
service.putJson = (path, params) => {
  return service({
    url: path,
    method: 'put',
    data: params,
    transformRequest: function (obj) {
      return JSON.stringify(obj)
    },
    headers: { 'Content-Type': 'application/json' }
  })
}

service.postFile = (path, params) => {
  return service({
    url: path,
    method: 'post',
    data: params,
    headers: { 'Content-Type': undefined }
  })
}
service.pageData = (that, isFirst, callback) => {
  that.pageInfo.params.page = that.pageInfo.params.page || 1;
  that.pageInfo.params.size = that.pageInfo.params.size || 1000;
  that.pageInfo.isFirst = isFirst;
  if (isFirst) {
    that.pageInfo.params.page = 1;
    that.pageInfo.TotalPage = 1;
    that.pageInfo.list = []
  }
  // console.log('getListByPage------->');
  if (that.pageInfo.params.page > that.pageInfo.TotalPage || that.pageInfo.isLoading) {
    return
  } else {
    that.pageInfo.isLoading = true;
    if (!that.pageInfo.hideLoading) {
      // that.Toast('加载中')
    }
    let postCb = function(res) {
      that.pageInfo.isLoading = false;
      that.pageInfo.all = res.all
      // wx.hideLoading();
      that.pageInfo.hideLoading = false
      if (isFirst) {
        that.pageInfo.list = res.list;
      } else {
        that.pageInfo.list = that.pageInfo.list.concat(res.list);
      }
      that.pageInfo.TotalPage = res.pages;

      if (that.pageInfo.params.page <= that.pageInfo.TotalPage) {
        that.pageInfo.params.page++;
      }
      if (callback) {
        callback(that.pageInfo);
      }
    }
    service.post(that.pageInfo.postUrl, that.pageInfo.params).then(res=>{
      if(res.code==200){
        postCb(res.data);
      }
    });

  }
}

export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js